import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/(homepage)/page.tsx")